import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/sharp-regular-svg-icons";
import type React from "react";
import { PrimaryButton, SecondaryButton } from "./Buttons";
import { Modal } from "./Modals";

interface ConfirmationDialogProps {
    visible: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title: string;
    message: React.ReactNode;
    confirmText?: string;
    cancelText?: string;
    loading?: boolean;
}

export const ConfirmationDialog = (props: ConfirmationDialogProps) => {
    return (
        <Modal
            visible={props.visible}
            onClose={() => {
                if (!props.loading) {
                    props.onClose();
                }
            }}
            size="sm"
        >
            <h2 className="text-lg font-semibold mb-3 mt-2">{props.title}</h2>
            <div className="text-sm mb-5">{props.message}</div>
            <div className="flex gap-2">
                <PrimaryButton
                    type="button"
                    onClick={props.onConfirm}
                    disabled={props.loading}
                >
                    {props.loading && (
                        <FontAwesomeIcon
                            icon={faSpinner}
                            className="animate-spin"
                        />
                    )}
                    {props.confirmText || "Confirm"}
                </PrimaryButton>
                <SecondaryButton
                    type="button"
                    onClick={props.onClose}
                    disabled={props.loading}
                >
                    {props.cancelText || "Cancel"}
                </SecondaryButton>
            </div>
        </Modal>
    );
};
